import Relay from 'react-relay';
import ObjectRelProducers from './ObjectRelProducers';
import ObjectRelPersonsPerson from '../Person';
import settings from '../../../../../config/settings';

const ObjectRelProducersContainer = Relay.createContainer(ObjectRelProducers, {
    initialVariables: {
        limit: settings.defaultLimitNumberOfRecords,
    },
    fragments: {
        object: () => Relay.QL`
            fragment on Object {
                id,
                ObjProducers(first: $limit) {
                    edges {
                        node {
                            PerId,
                            ${ObjectRelPersonsPerson.getFragment('person')}
                        }
                    }
                }
            }
        `,
    }
});

export default ObjectRelProducersContainer;


// WEBPACK FOOTER //
// ./app/components/Object/RelPersons/Producers/index.js